module.exports = __webpack_public_path__ + "static/media/ks_testtube5.cf4955b6.svg";